/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CreditCardPayInfo } from './CreditCardPayInfo';
import {
    CreditCardPayInfoFromJSON,
    CreditCardPayInfoFromJSONTyped,
    CreditCardPayInfoToJSON,
    CreditCardPayInfoToJSONTyped,
} from './CreditCardPayInfo';

/**
 * 
 * @export
 * @interface PaymentCreateRespVo
 */
export interface PaymentCreateRespVo {
    /**
     * 支付记录ID
     * @type {number}
     * @memberof PaymentCreateRespVo
     */
    paymentId?: number;
    /**
     * 
     * @type {CreditCardPayInfo}
     * @memberof PaymentCreateRespVo
     */
    creditCardPayInfo?: CreditCardPayInfo;
}

/**
 * Check if a given object implements the PaymentCreateRespVo interface.
 */
export function instanceOfPaymentCreateRespVo(value: object): value is PaymentCreateRespVo {
    return true;
}

export function PaymentCreateRespVoFromJSON(json: any): PaymentCreateRespVo {
    return PaymentCreateRespVoFromJSONTyped(json, false);
}

export function PaymentCreateRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaymentCreateRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'paymentId': json['paymentId'] == null ? undefined : json['paymentId'],
        'creditCardPayInfo': json['creditCardPayInfo'] == null ? undefined : CreditCardPayInfoFromJSON(json['creditCardPayInfo']),
    };
}

export function PaymentCreateRespVoToJSON(json: any): PaymentCreateRespVo {
    return PaymentCreateRespVoToJSONTyped(json, false);
}

export function PaymentCreateRespVoToJSONTyped(value?: PaymentCreateRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'paymentId': value['paymentId'],
        'creditCardPayInfo': CreditCardPayInfoToJSON(value['creditCardPayInfo']),
    };
}

